module.exports = __webpack_public_path__ + "static/media/icomoon.b3e4d9d8.woff";